export default __webpack_public_path__ + "static/media/Guar.6b6fa416.jpg";